import type { Location } from './schemas';

/**
 * Where the sun is computed when the family has not entered a home yet: the middle of the
 * household's time zone – never one particular town, so nobody sees another family's sky.
 * Germany's geographic centre is the default; neighbours get their own.
 */
const ZONE_CENTRES: Record<string, { latitude: number; longitude: number }> = {
  'Europe/Berlin': { latitude: 51.16, longitude: 10.45 },
  'Europe/Vienna': { latitude: 47.59, longitude: 14.14 },
  'Europe/Zurich': { latitude: 46.8, longitude: 8.23 },
  'Europe/Luxembourg': { latitude: 49.78, longitude: 6.09 },
  'Europe/Amsterdam': { latitude: 52.13, longitude: 5.29 },
  'Europe/Brussels': { latitude: 50.5, longitude: 4.47 },
  'Europe/Copenhagen': { latitude: 56.0, longitude: 10.0 },
  'Europe/Paris': { latitude: 46.6, longitude: 2.4 },
  'Europe/Warsaw': { latitude: 52.0, longitude: 19.1 },
  'Europe/Prague': { latitude: 49.8, longitude: 15.47 },
};

export function skyPlace(
  home: Location | null | undefined,
  timeZone: string,
): { latitude: number; longitude: number } {
  if (home) return { latitude: home.latitude, longitude: home.longitude };
  return ZONE_CENTRES[timeZone] ?? ZONE_CENTRES['Europe/Berlin']!;
}
